import type { FC } from 'react'
import React, { memo } from 'react'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { IndexPageSection, News } from '@/pages/IndexPage/components'
import { BestPromoOffers, ProductsCatalog, ProductsPromoBanner } from './components'
import './styles.scss'

const Inputs: FC = () => {
  const { userRegion } = useUserRegion()

  return (
    <>
      <IndexPageSection>
        <ProductsCatalog type="agroproducts" />
      </IndexPageSection>
      <IndexPageSection>
        <BestPromoOffers region={userRegion} />
      </IndexPageSection>
      <IndexPageSection>
        <ProductsPromoBanner type="agricultural" region={userRegion} />
      </IndexPageSection>
      <IndexPageSection>
        <ProductsCatalog type="machinery" />
      </IndexPageSection>
      <IndexPageSection>
        <ProductsPromoBanner type="machinery" region={userRegion} />
      </IndexPageSection>
      <IndexPageSection backgroundColor="grey">
        <News type="inputs" />
      </IndexPageSection>
    </>
  )
}

export default memo(Inputs)
